import React, { useState, useEffect } from "react"
import { useParams } from "react-router-dom"
import LayoutCommon from "src/components/Common/Layout"
import { allProducts, categories } from "../data/productsData"
import { Col, Row, Typography, Image, Button } from "antd"
import CardItem from "../components/CardProduct"
import { FilterOutlined } from "@ant-design/icons"
import FilterProduct from "./FilterProduct"
import CardCategory from "./CardCategory"
import { LayoutProductPage } from "../styled"
export default function DetailCategory() {
  const { categoryId } = useParams()
  const categoryIdNumber = parseInt(categoryId, 10)
  const { Title, Paragraph } = Typography
  const category = categories.find(c => c.id === categoryIdNumber)
  const products = allProducts.filter(p => p.categoryId === categoryIdNumber)
  const [drawerVisible, setDrawerVisible] = useState(false)
  const [filters, setFilters] = useState({
    sortBy: "",
    categories: [categoryIdNumber],
    priceRange: [0, 1000000000],
  })
  const filteredProducts = products
    .filter(
      p =>
        (filters.categories.length === 0 ||
          filters.categories.includes(p.categoryId)) &&
        p.price >= filters.priceRange[0] &&
        p.price <= filters.priceRange[1],
    )
    .sort((a, b) => {
      if (filters.sortBy === "price-low-high") return a.price - b.price
      if (filters.sortBy === "price-high-low") return b.price - a.price
      return 0
    })

  useEffect(() => {
    setFilters(prev => ({
      ...prev,
      categories: [categoryIdNumber],
    }))
  }, [categoryIdNumber])

  if (!category) {
    return <LayoutCommon>Danh mục không tồn tại</LayoutCommon>
  }

  return (
    <LayoutCommon>
      <Col span={24} style={{ marginTop: 24 }}>
        <Title level={2}>{category.title}</Title>
      </Col>

      <Col span={24} style={{ margin: 48 }}>
        <Row display="flex">
          <Col md={12} lg={12} xs={24} sm={24}>
            <Row>
              <Title level={2}>Tổng quan</Title>
            </Row>
            <Row>
              <Paragraph style={{ textAlign: "justify" }}>
                {category.description}
              </Paragraph>
            </Row>
          </Col>

          <Col md={12} lg={12} xs={24} sm={24} style={{ marginTop: 48 }}>
            <Image src={category.image} alt="phan-he" preview={false} />
          </Col>
        </Row>
      </Col>

      <Col span={24} style={{ marginTop: 48 }}>
        <Row justify={"space-between"}>
          <Title level={2}>Các sản phẩm</Title>

        </Row>
        <CardItem
          products={filteredProducts.map(p => p.id)}
          filters={filters}
        />
      </Col>


      <Col span={24} style={{ marginTop: 48 }}>
        <Row>
          <Title level={2}>Các danh mục khác</Title>
        </Row>
        <CardCategory excludeCategory={categoryIdNumber} />
      </Col>
    </LayoutCommon>
  )
}
